import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { selectUser } from "../../store/slice/user";
import { selectCountries } from "../../store/slice/countries";
import { IMAGES } from "../../theme";
import { Style } from "./style";

// Mirrors new-design/o7events-frontend's <footer> — brand blurb + 3 link
// columns (For Attendees / For Organizers / Company) + copyright bar.
const Footer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { language, countryId } = useSelector(selectUser);
  const countries = useSelector(selectCountries);
  const isArabic = language === "ar";

  const activeCountry = countries.find((c) => c?.id === countryId);
  const region =
    activeCountry?.translation?.[language]?.name || t("marketing.nav.everywhere");

  const openVendorLink = () => {
    window.open("https://admin.o7events.com/vendor", "_blank", "noopener,noreferrer");
  };

  const columns = [
    {
      heading: t("marketing.footer.forAttendees"),
      links: [
        { label: t("marketing.footer.browseEvents"), onClick: () => navigate("/") },
        { label: t("marketing.footer.howItWorks"), onClick: () => navigate("/how-it-works") },
        { label: t("marketing.footer.helpCenter"), onClick: () => navigate("/contact-sales") },
      ],
    },
    {
      heading: t("marketing.footer.forOrganizers"),
      links: [
        { label: t("marketing.footer.createEvent"), onClick: openVendorLink },
        { label: t("marketing.footer.pricing"), onClick: () => navigate("/pricing") },
        { label: t("marketing.footer.resources"), onClick: () => navigate("/how-it-works") },
        { label: t("marketing.nav.contactSales"), onClick: () => navigate("/contact-sales") },
      ],
    },
    {
      heading: t("marketing.footer.company"),
      links: [
        { label: t("marketing.footer.about"), onClick: () => navigate("/about") },
        { label: t("marketing.footer.privacyPolicy"), onClick: () => navigate("/privacy-policy") },
        { label: t("marketing.footer.termsOfService"), onClick: () => navigate("/terms-of-service") },
        { label: t("marketing.footer.refundPolicy"), onClick: () => navigate("/refund-policy") },
        { label: t("marketing.footer.modelsInfluencers"), onClick: () => navigate("/models-influencers") },
      ],
    },
  ];

  return (
    <Box component="footer" sx={Style.footer}>
      <Box sx={Style.content}>
        <Box>
          <Box sx={Style.logoContainer(isArabic)} onClick={() => navigate("/")}>
            <Box component="img" src={IMAGES.LogoIcon} sx={Style.logoImg} />
          </Box>
          <Typography sx={Style.description}>
            {t("marketing.home.heroFooterTagline", { region })}
          </Typography>
        </Box>
        {columns.map((col, i) => (
          <Box key={i}>
            <Typography sx={Style.sectionHeading(isArabic)}>{col.heading}</Typography>
            <Box component="ul" sx={Style.linkList}>
              {col.links.map((link, j) => (
                <Box component="li" key={j}>
                  <Typography component="span" sx={Style.link(isArabic)} onClick={link.onClick}>
                    {link.label}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        ))}
      </Box>
      <Box sx={Style.bottom}>{t("marketing.footer.copyright")}</Box>
    </Box>
  );
};

export default Footer;
